{
  "DATA_ASSISTANT": {
    "TITLE": "Data-assistent",
    "NEW_CONVERSATION": "+ Ny",
    "LOADING": "Indlæser...",
    "LOADING_MESSAGES": "Indlæser beskeder...",
    "THINKING": "Tænker...",
    "UNTITLED": "Unavngivet samtale",
    "NO_CONVERSATIONS": "Ingen samtaler endnu. Klik på \"+ Ny\" for at starte.",
    "EMPTY_STATE": "Vælg en samtale, eller opret en ny for at starte.",
    "PLACEHOLDER": "Hvad kan jeg finde ud af for dig?",
    "SHOW_SQL": "Vis SQL",
    "NO_ROWS": "Ingen rækker returneret.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Slet samtale",
    "DELETE_CONFIRM_DESCRIPTION": "Er du sikker på, at du vil slette denne samtale? Denne handling kan ikke fortrydes.",
    "DELETE_CONFIRM_YES": "Slet",
    "REPORTS": "Rapporter",
    "SAVE_TO_REPORT": "Gem i rapport",
    "NEW_REPORT": "Ny rapport",
    "REPORT_NAME": "Rapportnavn",
    "NO_REPORTS": "Ingen gemte rapporter endnu",
    "REPORTS_EMPTY_STATE": "Vælg en rapport, eller opret en ny.",
    "REPORT_SAVED": "Gemt i rapport",
    "DELETE_REPORT_CONFIRM": "Slet rapport",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Er du sikker på, at du vil slette denne rapport? Alle gemte elementer bliver fjernet.",
    "DELETE_ITEM_CONFIRM": "Fjern element",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Er du sikker på, at du vil fjerne dette element fra rapporten?",
    "EXPORT_CSV": "Eksporter CSV",
    "REFRESH": "Opdater",
    "QUERY_RUNNING": "Kører forespørgsel...",
    "QUERY_FAILED": "Forespørgslen mislykkedes",
    "AUTO_REFRESH": "Automatisk opdatering",
    "AUTO_REFRESH_NONE": "Manuel",
    "AUTO_REFRESH_30S": "30 sekunder",
    "AUTO_REFRESH_1M": "1 minut",
    "AUTO_REFRESH_5M": "5 minutter",
    "AUTO_REFRESH_10M": "10 minutter",
    "EDIT_MESSAGE": "Rediger besked",
    "RENAME_REPORT": "Omdøb rapport",
    "RENAME_ITEM": "Omdøb element",
    "MOVE_UP": "Flyt op",
    "MOVE_DOWN": "Flyt ned",
    "COLLABORATORS": {
      "BUTTON": "Samarbejdspartnere",
      "TITLE": "Samarbejdspartnere på rapporten",
      "DESCRIPTION": "Vælg hvilke agenter og teams der kan se denne rapport.",
      "AGENTS": "Agenter",
      "TEAMS": "Teams",
      "SELECT_AGENTS": "Vælg agenter",
      "SELECT_TEAMS": "Vælg teams",
      "SAVE": "Gem",
      "SAVED": "Samarbejdspartnere opdateret",
      "SAVE_FAILED": "Kunne ikke opdatere samarbejdspartnere"
    }
  }
}
